import { useMediaQuery, useTheme } from "@mui/material";

/**
 * Hook to determine device type based on screen size.
 * 
 * @returns {object} Device information
 * @property {boolean} isMobile - True for screens < 600px (Material-UI 'sm' breakpoint)
 * 
 * @note This uses Material-UI's 'sm' breakpoint (600px). The CSS media queries in
 * app.less should use `@media (max-width: 599px)` to ensure consistent mobile detection
 * between JavaScript and CSS styling.
 */
export function useDeviceInfo(): {
    isMobile: boolean;
} {
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return {
        isMobile
    };
}
